export type PendoGuide = {
  id: string
  show: () => void
  steps: {
    containerId: string
  }[]
}

export enum PendoEvent {
  Account_Visibility_Modal = 'Account_Visibility_Modal',
  New_Accounts_Created_Modal = 'New_Accounts_Created_Modal',
  Visual_Assortment_Refresh_Message = 'Visual_Assortment_Refresh_Message',
  Visual_Assortment_Product_Rearranged = 'Visual_Assortment_Product_Rearranged',
  Visual_Assortment_Card_Selected = 'Visual_Assortment_Card_Selected',
  Visual_Assortment_Filter_Applied = 'Visual_Assortment_Filter_Applied',
  Visual_Assortment_Grouping_Applied = 'Visual_Assortment_Grouping_Applied',
  Visual_Assortment_Initialized = 'Visual_Assortment_Initialized',
  Find_New_Retailers_Search_Executed = 'Find_New_Retailers_Search_Executed',
  Find_New_Retailers_Filters_Applied = 'Find_New_Retailers_Filters_Applied',
}
